
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/society/environment",
      function () {
        return require("private-next-pages/csr/society/environment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/society/environment"])
      });
    }
  